import TomSelect from 'tom-select';
// import TomSelect from 'tom-select/dist/js/tom-select.complete.min.js';

function tomSelectSetup() {

  document.querySelectorAll(".tom-select-bucket-copy-multiple").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, { maxOptions: null });
    }
  });

  document.querySelectorAll(".tom-select-database-multiple").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, { maxOptions: null });
    }
  });

  document.querySelectorAll(".tom-select-workspace-users-multiple").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, { maxOptions: null });
    }
  });

  document.querySelectorAll(".tom-select-deploy-validation-user").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, { allowEmptyOption: true });
    }
  });

  document.querySelectorAll(".tom-select-deploy-validation-project").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, { allowEmptyOption: true });
    }
  });

  document.querySelectorAll(".tom-select-deploy-validation-approved").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, {});
    }
  });

  document.querySelectorAll(".tom-select-deploy-validation-reviewed").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, {});
    }
  });

  document.querySelectorAll(".tom-select-basic").forEach(el => {
    if (!el.tomSelect) {
      el.tomSelect = new TomSelect(el, {});
    }
  });
};


document.addEventListener('DOMContentLoaded', function () {
  tomSelectSetup();
});

document.addEventListener('turbo:load', function () {
  tomSelectSetup();
});

document.addEventListener('turbo:render', function () {
  tomSelectSetup();
});

document.addEventListener('turbo:morph', function () {
  tomSelectSetup();
});

// The Fabric workspace access manager (with its users multiselect) is loaded lazily
// into the shared modal via a Turbo Frame, which fires turbo:frame-load rather than
// turbo:load. Re-run setup so the freshly loaded select becomes a tom-select.
document.addEventListener('turbo:frame-load', function () {
  tomSelectSetup();
});

// Re-initialize after a Turbo Stream update, but only when the incoming content
// actually contains a tom-select element
document.addEventListener('turbo:before-stream-render', function (event) {
  const originalRender = event.detail.render;
  event.detail.render = function (streamElement) {
    const touchesTomSelect = streamElement.templateContent
      && streamElement.templateContent.querySelector('[class*="tom-select-"]');
    originalRender(streamElement);
    if (touchesTomSelect) tomSelectSetup();
  };
});

